<template>
    <div class="system-images list-page page">
        <div v-for="item in tableData" :key="item.id" class="imageItems">
            <div class="avatar-box">
                <img v-if="item.headImage" :src="item.headImage" class="preview-avatar" alt="" />
                <i v-else class="el-icon-user-solid avatar-placeholder"></i>
            </div>
            <div class="image-name">{{ item.name }}{{ item.regionName ? `(${item.regionName})` : '' }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {},
        data() {
            return {
                tableData: [],
            };
        },
        created() {
            this.fetchData();
        },
        mounted() {},
        watch: {},
        computed: {},
        methods: {
            async fetchData() {
                const loading = this.$loading();
                try {
                    const res = await this.$axios({
                        url: '/api/employee/getHeadImgList',
                        method: 'post',
                    });

                    if (res.code === 2000) {
                        res.data.list.forEach(item => {
                            if (item.headImage) {
                                item.headImage = this.$baseURL + '/' + item.headImage;
                            }
                        });

                        this.tableData = res.data.list;
                        loading.close();
                    } else if (res.code !== 1003) throw res;
                } catch (reason) {
                    console.warn('获取数据失败', reason);
                    this.$message({
                        message: reason.msg || '获取数据失败',
                        type: 'warning',
                    });

                    loading.close();
                }
            },
        },
    };
</script>
<style lang="scss" scoped>
    .system-images {
        display: grid;
        grid-template-columns: repeat(auto-fill, 160px);
        grid-auto-rows: 260px; // 行高也写死，跟卡片一致
        justify-content: start; // 水平方向左对齐，不撑满
        align-content: start; // 垂直方向顶对齐，不撑满 ← 关键
        gap: 20px;
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
        height: auto; // 由内容撑开，不继承父级高度
    }

    .imageItems {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;

        width: 160px;
        height: 248px;
        flex-shrink: 0; // 防止被压缩变形

        padding: 16px 12px;
        background: #fff;
        border: 1px solid #ebeef5;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.25s ease;

        &:hover {
            border-color: #c6e2ff;
            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
            transform: translateY(-2px);
        }
    }

    // 图片容器：固定宽高，无论有没有图都占位一致
    .avatar-box {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 112px;
        height: 162px;
        margin-bottom: 12px;
        background: #f5f7fa;
        overflow: hidden;
    }

    .preview-avatar {
        width: 112px;
        height: 162px;
        object-fit: cover; // 关键：不变形，统一裁切
        display: block;
    }

    .avatar-placeholder {
        font-size: 40px;
        color: #c0c4cc;
    }

    .image-name {
        width: 100%;
        font-size: 14px;
        color: #303133;
        line-height: 1.4;
        text-align: center;
        word-break: break-all;

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; // 最多两行
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
